import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink,
    FetchCompanyInventoriesUrl,
    UpdateRoomInventoryUrl,
} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Animation} from "./Animation";
import MobileLinkLoader from "./MobileLinkLoader";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const AddInventories = () => { // this component is used to reflect all companies inventories
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    const [CompanyInventories, SetCompanyInventories] = useState({});
    const [SearchInventory, SetSearchInventory] = useState({});
    const [NewInventoryCount, increaseNewInventoryCount] = useState(0);
    const Room = RecordController.Room
    const [, forceUpdate] = React.useState(0);
    const [Change, SetChange] = useState(false);
    const [BodyState, setBodyState] = useState("MINI-LOADING");
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;

    useEffect(() => {
        if(RecordController.Click){
            Animation('add_inventories', RecordController.Click)// add animation on a page
        }
        axios({
            method: 'post',
            url: FetchCompanyInventoriesUrl,
            params: {estimate_key: Elink}
        }).then(async (response) =>{
            await setBodyState('Get Details')
            await SetCompanyInventories(response.data); // fetch company inventories
            await SetSearchInventory(response.data);
        });
    }, [])

    const searchText = (e) => {//used for searching the inventories
        let text = e.toLowerCase();
        let searchData = {}
        Object.entries(CompanyInventories).map(([id, inventories]) => {
            let inventory = inventories.Name.toLowerCase();
            if (inventory.match(text)) {
                searchData[inventories.Id+"item"] = inventories
            }
        })
        SetSearchInventory(searchData);
    };

    const UpdateQty = (inventory, type, inventory_id) => { // used for increase or decrease the quantity
        SetChange(true);// set true if update changes
        if (inventory_id !== '') {
            let isAlreadyExist = false,
                InventoryId = 0,
                COMPANY_INVENTORY = CompanyInventories[inventory_id],
                COUNT = NewInventoryCount

            if (CompanyInventories != null) {
                let inventories = CompanyInventories
                Object.entries(inventories).map(([id, Inventory]) => {
                    if (Inventory.Id === inventory_id) {
                        isAlreadyExist = true
                        InventoryId = id
                    }
                })
                if (isAlreadyExist === true && InventoryId !== 0) {
                    if (type === 'Increment') {
                        inventories[InventoryId].Qty += 1
                    } else if (type === 'Decrement' && inventories[InventoryId].Qty > 0) {
                        inventories[InventoryId].Qty -= 1
                    }
                } else if (isAlreadyExist === false && InventoryId === 0 && type === 'Increment') {
                    inventories[inventory_id] = {
                        Id: inventory_id,
                        Name: COMPANY_INVENTORY.Name,
                        Qty: 1,
                        InventoryId: COMPANY_INVENTORY.Id,
                    }
                    increaseNewInventoryCount(COUNT += 1)
                }
                SetCompanyInventories(inventories);
                forceUpdate(n => !n);
            }
        }
    }

    const BackToRoomPage =() => { // component is used to go back
        if(Change) {
            updateRoomInventory("room_page");
        }else{
            RecordController.SetClick("downward"); // set animation class
            AnimationPrevious ( "downward-go",  "add_inventories",  "MOBILE_ROOM_DETAIL", PageView); // set leave animation
        }
    }

    const UpdateInventories = () =>{ // update inventories
        RecordController.SetDone(true);
        updateRoomInventory("room_page");
    }
    const CustomItem =()=>{ // add new custom item
        if(Change){
            updateRoomInventory("custom_page");
        }else{
            RecordController.SetClick("next");
            AnimationPrevious ( "next-go",  "add_inventories",  "CUSTOM_ITEM_PAGE", PageView);
        }
    }

    const updateRoomInventory=(page)=>{
        setBodyState("MINI-LOADING");
        axios({//post request is send to the "update_inventories" function for updating the inventories of the estimate.
            method: 'post',
            url: UpdateRoomInventoryUrl,
            data: {
                estimate_key: Elink,
                room_est_id: Room.Id,
                inventories: CompanyInventories,
                inventory_estimates: RecordController.RoomInventories,
                floor_id: Room.FloorId,
                room_id: Room.RoomId
            }
        }).then(async (response) => {
            let Message = response.data.Message
            let current_location = window.location.href;
            let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
            if(Message && Message.Text === "Expired Link"){
                window.location = new_location
            }
            else{
                if (Message && Message.Status && Message.Status === "failed") {
                    PageView.setAlertProperty({
                        Message: Message.Text,
                        Type: Message.Type,
                        Show: true,
                        AutoHide: true
                    })
                    window.location.reload();
                }
                await page === "room_page" ? RecordController.SetClick('downward') : RecordController.SetClick('next');
                await page === "room_page" ? AnimationPrevious("downward-go", "add_inventories", "MOBILE_ROOM_DETAIL", PageView)
                    : AnimationPrevious("next-go", "add_inventories", "CUSTOM_ITEM_PAGE", PageView)
                await RecordController.setRoom(response.data);
            }
        })
    }

    const AllInventories=(device)=> { // this component is used to show all inventories in aplhabet order
        return(
            Object.entries(SearchInventory).map(([id, Inventory]) => {
                return (
                    <div key={"MobileInventory" + Inventory.Id} id={device === "mobile-vw" ?
                        "MobileInventoryList" + Inventory.Id : "DesktopInventoryList" + Inventory.Id}
                         className={Inventory.Qty > 0 ? "alpha-list-scrollbar-active" : "alpha-list-scrollbar"}
                         style={Inventory.Qty > 0 ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>
                        <span className={'minus'} style={{cursor: "pointer"}}
                              onClick={() => UpdateQty(Inventory, 'Decrement', Inventory.Id)}>{'-'}</span>
                        <p className="text-design text-design-1"style={{marginBottom: "0px"}}>{Inventory.Name}</p>
                        <div className="input-st">
                            <input type="text" pattern="[0-9]*"
                                   style={{fontSize: "15px!important", padding: "0px", backgroundColor: Inventory.Qty > 0 ? GetTextColor(CustomerInvReq.ButtonColor) : "", color: Inventory.Qty > 0 ? CustomerInvReq.ButtonColor :''}}
                                   defaultValue={Inventory.Qty > 0 ? Inventory.Qty : ''}
                                   disabled/>
                        </div>
                        <span className={'plus'} style={{cursor: "pointer"}}
                              onClick={() => UpdateQty(Inventory, 'Increment', Inventory.Id)}>{'+'}</span>
                    </div>
                )
            })
        )
    }

    const findItems = async (alphabet,device) => { // sorting the items
        await SetSearchInventory(SearchInventory)
        let findAlphabet = await false
        let element ,element_id
        Object.entries(CompanyInventories).map(async ([id, inventories]) => {
            if (findAlphabet === true) {
                return;
            }
            if (inventories.Name.charAt(0).toUpperCase() === alphabet) {
                element_id = device === "mobile-vw" ? "MobileInventoryList" + inventories.Id :
                    "DesktopInventoryList" + inventories.Id
                element = document.getElementById(element_id)
                element.parentNode.parentNode.scrollTop = element.offsetTop;
                findAlphabet = true
            }
        })
    }

    const AddNewItems = (device) => {
        const options = [];
        for (let i = 65; i < 91; i++) {
            options.push(<li className="nav-link-li" onClick={() => findItems(String.fromCharCode(i),device)}>{String.fromCharCode(i)}</li>);
        }
        return (
            <>
                <div className="container">
                    <div className="row add-inventories-row">
                        <div className="col-md-2 col-lg-3 col-xl-3">
                            <div className="">
                                <button className="btn-st-back btn-back" type="submit" onClick={()=>BackToRoomPage()}
                                        style={{borderRadius: "8px", color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}}>Back</button>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6 ">
                            <div className="header-tx text-center">
                                <div className="cross" onClick={()=>BackToRoomPage()}>
                                    <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "25px"}}></i>
                                </div>
                                <h3 id="add-item-heading" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Add item in {Room.Name}</h3>
                            </div>
                        </div>
                        <div className="col-md-2 col-lg-3 col-xl-3">
                        </div>
                    </div>
                    {/* add loader, sometimes it take time to load all inventories */}
                    {BodyState === "MINI-LOADING" ? <MobileLinkLoader Height={"60vh"}/> :
                        <>
                        <div className="text-center search-bar-margin add_inventories_search" style={{marginTop: "5rem"}}>
                            <div className="row d-flex justify-content-center align-items-center h-100">
                                <div className="col-sm-12 col-md-9 col-lg-7 col-xl-6"
                                     style={{padding: "0px", flex: "0 0 96%"}}>
                                    <div className="form-group search-bar">
                                        <input type="text" className={"form-control"} style={{margin: "auto"}}
                                               onKeyUp={(e) => searchText(e.target.value)}
                                               placeholder={"Item Search"}/>
                                    </div>
                                    <div className="row">
                                        <div className="col-10 col-lg-10 counter-st-2"
                                             style={{padding: "0px", marginBottom: "1%"}}>
                                            <div className="col" style={{marginTop: "1%", padding: "0px"}}>
                                                {AllInventories(device)}
                                            </div>
                                        </div>
                                        <ul className="col-2" style={{padding: "0px", marginTop: "1%"}}>
                                            {options}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row button-container">
                            {
                                CustomerInvReq.AllowCustomItem ?
                                    <button className="col buttons-cs" type="submit" onClick={()=>CustomItem()}
                                    style={{ color: CustomerInvReq.ButtonColor, borderColor:CustomerInvReq.ButtonColor}}>
                                        <b>CUSTOM ITEM</b>
                                    </button>
                                    : ''
                            }
                            <button className="col btn buttons-d" type="submit" onClick={()=> UpdateInventories()}
                            style={{color: GetTextColor(CustomerInvReq.ButtonColor), background: CustomerInvReq.ButtonColor}}><b>DONE</b></button>
                        </div>
                        </>
                    }
                </div>
            </>
        )
    }

    return (
        <>
            <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}>  {/*desktop view*/}
                <div className={"add_inventories"} style={{width: "100vw"}}>
                    {AddNewItems("desktop-vw")}
                </div>
            </section>
            <section className="mobile-vw"> {/*mobile view*/}
                <div className={"add_inventories"} style={{width: "100vw"}}>
                    <div className="container-mv">
                        <svg viewBox="0 0 500 500"
                             preserveAspectRatio="xMinYMin meet"
                             style={{zIndex: -1}} id="svg-mv">
                            <path d="M0, 170 C360, 30, 630,
                510 595,-400 L900, 00 L0, 0 Z"
                                  style={{stroke: "none",fill: CustomerInvReq.BackgroundColor}}>
                            </path>
                        </svg>

                    </div>
                    {AddNewItems("mobile-vw")}
                </div>
            </section>
        </>
    )
}
export default AddInventories;